import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IAccount } from '@account-users';

import { Template } from '../../models/Template';
import { CopyTemplate } from '../../models/CopyTemplate';

@Component({
  selector: 'app-copy-template-modal',
  templateUrl: './copy-template-modal.component.html',
  styleUrls: ['./copy-template-modal.component.scss'],
})
export class CopyTemplateModalComponent {
  @Input() accounts: IAccount[] = [];
  @Input() templates: Template[] = [];
  @Input() copyTemplateError: HttpErrorResponse;
  @Output() copyTemplate = new EventEmitter<CopyTemplate>();
  @Output() fetchTemplates = new EventEmitter<string>();

  constructor(public activeModal: NgbActiveModal) {}
}
